/**
 * Exports props for schema.org specifications
 * http://schema.org/
 */

// @flow
export default function schema({
  itemProp, itemType,
}) {
  return {
    itemProp,
    itemScope: "itemScope",
    itemType: `http://schema.org/${itemType}`,
  };
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schema.js